export default function getAvatarUrl(model, folder = 'user_avatar') {
    if (Array.isArray(model.media) && model.media.length) {
        return `${bucket}/${model.media[0].id}/${model.media[0].file_name}`;
    } else {
        return `/img/${folder}/unknown_picture.png`;
    }
}
